__turbopack_context__.v({
  "active": "SimpleHeaderMenu-module-scss-module___eWvUa__active",
  "footerMenu": "SimpleHeaderMenu-module-scss-module___eWvUa__footerMenu",
  "menuList": "SimpleHeaderMenu-module-scss-module___eWvUa__menuList",
  "menuListItem": "SimpleHeaderMenu-module-scss-module___eWvUa__menuListItem",
  "menuWrapper": "SimpleHeaderMenu-module-scss-module___eWvUa__menuWrapper",
  "visible": "SimpleHeaderMenu-module-scss-module___eWvUa__visible",
});
